import { EditorState, Modifier } from 'draft-js';

/*
 * Indents or unindents blocks as well as texts with newlines
 */

const changeIndent = (editorState, tabCharacter, filterBlock, isDedent) => {
    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const blockMap = contentState.getBlockMap();
    const blockKeys = blockMap.keySeq();
    const selectionStartKey = selection.getStartKey();
    const selectionEndKey = selection.getEndKey();
    let startKey = selectionStartKey;
    let endKey = selectionEndKey;

    const startBlock = contentState.getBlockForKey(startKey);
    const blockAfterStart = contentState.getBlockAfter(startKey);
    const blockBeforeEnd = contentState.getBlockBefore(endKey);
    let startOffset = selection.getStartOffset();
    let endOffset = selection.getEndOffset();

    if (startBlock.getText().length <= startOffset && blockAfterStart != null) {
        startKey = blockAfterStart.getKey();
        startOffset = 0;
    }

    if (endOffset === 0 && blockBeforeEnd != null) {
        endKey = blockBeforeEnd.getKey();
        endOffset = blockBeforeEnd.getText().length;
    }

    const startIndex = blockKeys.indexOf(startKey);
    const endIndex = blockKeys.indexOf(endKey);

    const newContentState = blockMap.filter((block) => {
        const blockIndex = blockKeys.indexOf(block.getKey());
        return blockIndex >= startIndex && blockIndex <= endIndex;
    }).filter(filterBlock).reduce((reducedContent, block) => {
        const key = block.getKey();
        const blockStartOffset = startKey === key ? startOffset : 0;
        const blockEndOffset = endKey === key ? endOffset : block.getText().length;

        const lines = block.getText().split('\n');

        const startLineIndex = block.getText().slice(0, blockStartOffset).split('\n').length - 1;
        const endLineIndex = block.getText().slice(0, blockEndOffset).split('\n').length - 1;

        const newText = lines.map((text, index) => {
            const isLineSelected = startLineIndex <= index && endLineIndex >= index;
            if (isDedent === true && isLineSelected) {
                return text.replace(/^\s{1,4}/, '');
            } if (isLineSelected && text.trim().length > 0) {
                return `${tabCharacter}${text}`;
            }
            return text;
        }).join('\n');

        return Modifier.replaceText(
            reducedContent,
            selection.merge({
                anchorKey: key,
                focusKey: key,
                anchorOffset: 0,
                isBackward: false,
                focusOffset: block.getText().length,
            }),
            newText,
        );
    }, contentState);

    let newAnchorOffset = selection.getStartOffset()
    + (
        newContentState.getBlockForKey(selection.getStartKey()).getText().split('\n')[
            newContentState.getBlockForKey(selection.getStartKey()).getText().slice(0, selection.getStartOffset()).split('\n').length - 1
        ].length
      - contentState.getBlockForKey(selection.getStartKey()).getText().split('\n')[
          contentState.getBlockForKey(selection.getStartKey()).getText().slice(0, selection.getStartOffset()).split('\n').length - 1
      ].length
    );

    if (selection.getStartOffset() === 0 || newAnchorOffset < 0) {
        newAnchorOffset = 0;
    }

    const newFocusOffset = selection.getEndOffset()
    + (
        newContentState.getBlockForKey(selection.getEndKey()).getText().length
      - contentState.getBlockForKey(selection.getEndKey()).getText().length
    );

    const newSelection = selection.merge({
        anchorOffset: newAnchorOffset,
        isBackward: false,
        focusOffset: newFocusOffset,
    });

    return EditorState.forceSelection(
        EditorState.push(
            editorState,
            newContentState,
        ),
        newSelection,
    );
};

export default changeIndent;
